import React, {Component, useState} from "react";
import '../../components_style/RegisterForm.css'

import '../../components_style/rtl_css/RegisterForm.css'
import {adminApi} from "../../services/ApiService";

import SvGraphics from "../../assets/SvGraphics";
import DatePicker from "react-datepicker";
import * as XLSX from 'xlsx';


const Marital_statusObj={'Single':"רווק/ה", 'common-law-marriage':"ידוע/ה בציבור",
    'Married':"ידוע/ה בציבור", 'Separeted':"פרוד/ה", 'Divorced':"גרוש/ה", 'Widowed':"אלמן/נה", 'Other':"אחר"}


const GenderObj={ "Female" :"נקבה" , "Male":  "זכר", "Specified" : "לא ידוע"}
const EducationObj={ "Elementary" :"יסודית" , "HighSchool":  "תיכונית", "Academic" : "אקדמית", "Other" : "אחר"}

const InsuranceObj={ "1" :"מכבי" , "2":  "כללית", "3" : "לאומית", "4" : "מאוחדת",
    "5" : "חברת ביטוח", "6" : "צה\"ל", "7" : "משרד הביטחון", "8" : "אין", "9" : "רשות פלסטינאית", "10" : "אחר"}


const calculateAge = (dateOfBirth) => {
    const today = new Date();
    const birthDate = new Date(dateOfBirth);
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();

    if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }

    return age;
}


const AdminGenerateRequestReport = (props) => {

    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());

    const closeSideBar = async () => {
        props.closeSideBar(false)
    }
    const generateReport = async () => {
        let startDateText=startDate.toISOString().split('T')[0]
        let endDateText=endDate.toISOString().split('T')[0]

        startDate.setHours(0)
        startDate.setMinutes(0)
        startDate.setSeconds(0)
        startDate.setMilliseconds(0)

        let response = await adminApi.generateRequestsReport(startDate, endDate)

        if (response && response.data) {
            let requests =response.data.requests

            const dataToExport = [
                ['RequestID','choose_programm','requestStatus','requestDate','isCompleted','isPayed','Sum','paymentDate','MediatorCode',
                    'ID_passport','First_name','Last_name','Gender','Date_of_birth','Age','doctors_referral','Marital_status','Education','Insuring_factor',
                    'cityID','Phone_num1','Phone_num2','Email','Additional_Email',
                    'Validity_of_prescription','Driving','Ministry_Interior_matters','Smoker',
                    'Psychiatric_diagnosis','Consuming_license','Cannabis_freq_past_year','Smoked_cannabis','main_reason_for_using_medical_cannabis',
                    'AcceptFutureContact','medical_diagnoses_icd_code',"patient_indication",'prescription_validity','visit_summary'
                    ,'MedicalConditions','Status','statusText'],
            ];


          /*      t('patient_self_boarding.Pain'),
                t('patient_self_boarding.Palliative'),
                t('patient_self_boarding.Cancer'),
                t('patient_self_boarding.Neurologic_disease'),
                t('patient_self_boarding.Psychiatric_condition'),
                t('patient_self_boarding.Gastrointestinal_disease'),
                t('patient_self_boarding.Infectious_disease'),
                t('patient_self_boarding.Rheumatologic_disease'),
                t('patient_self_boarding.Unknown'),
                t('patient_self_boarding.other')
*/

            for (let i = 0; i < requests.length; i++) {

                let currentRequest= requests[i]
                let entryToAdd=[]
                let choose_programm =currentRequest.choose_programm ==='new'?'הוצאת רישיון חדש':
                    currentRequest.choose_programm ==='renew'?'חידוש רישיון למטופלים קיימים':
                        currentRequest.choose_programm ==='renew2'?'חידוש רישיון למטופלים חדשים':
                currentRequest.choose_programm ==='newPrescription'?'הוצאת מרשם חדש':
                    currentRequest.choose_programm ==='renew2Prescription'?
                        'חידוש מרשם למטופלים חדשים':'חידוש מרשם למטופלים  קיימים'


                let genderText = GenderObj[currentRequest.Patient?.PII?.Gender]

                let Marital_statusText= Marital_statusObj[currentRequest.Patient?.PII?.Marital_status]
                let EducationText= EducationObj[currentRequest.Patient?.PII?.Education]
                let InsuranceText= InsuranceObj[currentRequest.Patient?.PII?.Insuring_factor]
                let status = currentRequest.Patient?.PII?.User?.Enabled === 1?"Active":"Locked"
                let patient_conditions= currentRequest.Patient_conditions?currentRequest.Patient_conditions:[]
                let med_cond=[]
                patient_conditions.forEach(item=> {
                    if (item.Medical_condition) {
                        med_cond.push(item.Medical_condition.Condition_description_he)
                    }
                })

                let indication= currentRequest.Habits_Medicals[0]?.patient_indication
                indication= indication==="BehavioralDisturbance"?"הפרעת התנהגות – ספקטרום אוטיסיטי":indication
                indication= indication==="BehavioralDisturbance2"?"הפרעת התנהגות - דמנציה":indication

                entryToAdd.push(currentRequest.RequestID)
                entryToAdd.push(choose_programm)
                entryToAdd.push(currentRequest.RequestStatus?.status_desc_he)
                entryToAdd.push(currentRequest.requestDate)
                entryToAdd.push(currentRequest.isCompleted?"Yes":"No")
                entryToAdd.push(currentRequest.PatientsPayments?"Yes":"No")
                entryToAdd.push(currentRequest.PatientsPayments?currentRequest.PatientsPayments.Sum:"")
                entryToAdd.push(currentRequest.PatientsPayments?currentRequest.PatientsPayments.paymentDate:"")
                entryToAdd.push(currentRequest.MediatorCode)
                entryToAdd.push(currentRequest.Patient?.PII?.ID_passport.substring(0,3))
                entryToAdd.push(currentRequest.Patient?.PII?.First_name)
                entryToAdd.push(currentRequest.Patient?.PII?.Last_name)
                entryToAdd.push(genderText?genderText:'')
                entryToAdd.push(currentRequest.Patient?.PII?.Date_of_birth)
                entryToAdd.push(calculateAge(currentRequest.Patient?.PII?.Date_of_birth))
                entryToAdd.push(currentRequest.Patient_type_indications[0]?.doctors_referral)
                entryToAdd.push(Marital_statusText?Marital_statusText:'')
                entryToAdd.push(EducationText?EducationText:'')
                entryToAdd.push(InsuranceText?InsuranceText:'')
                entryToAdd.push(currentRequest.Patient?.PII?.City?.cityName)
                entryToAdd.push(currentRequest.Patient?.PII?.Phone_num1)
                entryToAdd.push(currentRequest.Patient?.PII?.Phone_num2)
                entryToAdd.push(currentRequest.Patient?.PII?.Email)
                entryToAdd.push(currentRequest.Additional_Email)

                entryToAdd.push(currentRequest.Habits_Medicals[0]?.Validity_of_prescription)
                entryToAdd.push(currentRequest.Habits_Medicals[0]?.Driving)
                entryToAdd.push(currentRequest.Habits_Medicals[0]?.Ministry_Interior_matters)
                entryToAdd.push(currentRequest.Habits_Medicals[0]?.Smoker)
                entryToAdd.push(currentRequest.Habits_Medicals[0]?.Psychiatric_diagnosis)
                entryToAdd.push(currentRequest.Habits_Medicals[0]?.Consuming_license)
                entryToAdd.push(currentRequest.Habits_Medicals[0]?.Cannabis_freq_past_year)
                entryToAdd.push(currentRequest.Habits_Medicals[0]?.Smoked_cannabis)
                entryToAdd.push(currentRequest.Habits_Medicals[0]?.main_reason_for_using_medical_cannabis)
                entryToAdd.push(currentRequest.Patient_type_indications[0]?.AcceptFutureContact)
                entryToAdd.push(currentRequest.Habits_Medicals[0]?.medical_diagnoses_icd_code)
                entryToAdd.push(indication)
                entryToAdd.push(currentRequest.Habits_Medicals[0]?.prescription_validity)
                entryToAdd.push(currentRequest.Habits_Medicals[0]?.visit_summary)
                entryToAdd.push(med_cond.join(','))
                entryToAdd.push(status)
                entryToAdd.push(currentRequest.statusText)

                let patient_products= currentRequest.Patient_treatments ?currentRequest.Patient_treatments :[]
                patient_products.forEach((item,index)=> {
                    let findIndex= dataToExport[0].findIndex(item=> item === ("Treatment Category " + (index+1)))
                    if(findIndex<0){
                        dataToExport[0].push("Treatment Category " + (index+1))
                        dataToExport[0].push("Treatment Intake Method " + (index+1))
                        dataToExport[0].push("Treatment Monthly Dosage " + (index+1))
                    }
                    entryToAdd.push(requests[i].Patient_treatments[index].TreatmentCategory?requests[i].Patient_treatments[index].TreatmentCategory:'')
                    entryToAdd.push(requests[i].Patient_treatments[index]['TreatmentIntakeMethod']?requests[i].Patient_treatments[index]['TreatmentIntakeMethod']:'')
                    entryToAdd.push(requests[i].Patient_treatments[index]['TreatmentMonthlyDosage']?requests[i].Patient_treatments[index]['TreatmentMonthlyDosage']:'')

                })



                dataToExport.push(entryToAdd)
            }

            const workbook = XLSX.utils.book_new();
            const worksheet = XLSX.utils.aoa_to_sheet(dataToExport);
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
            const excelBuffer = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'});

            const blob = new Blob([excelBuffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'});
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `requestsReport-${startDateText}_${endDateText}.xlsx`);
            document.body.appendChild(link);
            link.click();

        }

        props.closeSideBar(false)
    }


    let display = props.isSideBarOpen ? 'block' : 'none'
    let width = props.isSideBarOpen ? "600px" : "0px"
    let container_width = props.isSideBarOpen ? "100%" : "0px"
    const {t} = props

    return (
        <div className={"sidenav-complete"} style={{width: container_width, height: "100%"}}>
            <div className={"sidenav"} style={{width: width, height: "100%", float: 'right'}}>
                <SvGraphics onClick={closeSideBar.bind(this)} className={'close-bar-x'} svgname={'close'}
                            height={'15px'} width={'15px'} style={{
                    float: 'left',
                    top: '10px',
                    left: '10px',
                    position: 'absolute',
                    cursor: 'pointer'
                }}/>
                <div className={'register-form-title container block'}>
                    <h3 className={'h-centered block'}>{props.title}</h3>
                </div>

                <div style={{margin: '20px'}}>
                    <div className={'date-label-block'}>
                        <label className={'date-label'}> {t('hcpLeumitPatientRequests.startDate')}</label>

                        <DatePicker
                            // wrapperClassName={'date-component'}
                            showYearDropdown={true} showMonthDropdown={true}
                            dateFormat="dd/MM/yyyy"
                            selected={startDate}
                            maxDate={new Date()}
                            onChange={(event) => setStartDate(event)}/>
                    </div>

                    <div className={'date-label-block'}>
                        <label className={'date-label'}> {t('hcpLeumitPatientRequests.endDate')}</label>
                        <DatePicker
                            // wrapperClassName={'date-component'}
                            showYearDropdown={true} showMonthDropdown={true}
                            dateFormat="dd/MM/yyyy"
                            selected={endDate}
                            maxDate={new Date()}
                            onChange={(event) => setEndDate(event)}/>
                    </div>

                </div>


            </div>
            <div className={'register-form-nav-container block'}>
                <div className={'register-form-nav'}
                     style={{width: width, display: 'flex', justifyContent: "space-around"}}>
                    <button type={"button"} onClick={() => generateReport()} style={{display: display}}
                            className={"btn btn-primary save-info"}>
                        {t('hcpLeumitPatientRequests.generateReportPatients')}
                    </button>

                    <button type={"button"} onClick={() => closeSideBar()} style={{display: display}}
                            className={"btn btn-primary save-info"}>
                        {t('admin.hcp.form.close')}
                    </button>
                </div>
            </div>
        </div>
    )



}
export default AdminGenerateRequestReport;



